import { jsx as m } from "react/jsx-runtime";
import { useState as r, useMemo as z, useEffect as C } from "react";
import f from "./index10.js";
import { useElementSize as D } from "./index11.js";
import { transformUrlParamsToCropParams as U } from "./index6.js";
import { adjustDimensionsForAspectRatio as X } from "./index12.js";
const Q = ({
  src: t,
  alt: H = "Cropped image",
  contentResize: s = "fill",
  absolutePositioning: b = !1,
  onError: v,
  onLoad: o,
  ...E
}) => {
  const [j, l] = r(!0), [w, $] = r({
    width: "100%",
    height: "100%"
  }), [u, x] = r({ width: "100%", height: "100%" }), [y, S] = r({ x: 0, y: 0 }), [F, d] = r(1), [M, p] = r(1), [a, A] = r(), e = z(
    () => U(t),
    [t]
  ), { ref: R, size: h } = D(), I = (i) => {
    A(i), o == null || o(
      { width: i.naturalWidth, height: i.naturalHeight },
      {
        width: i.naturalWidth * ((e == null ? void 0 : e.width) || 100) / 100,
        height: i.naturalHeight * ((e == null ? void 0 : e.height) || 100) / 100
      }
    );
  };
  C(() => {
    if ((a == null ? void 0 : a.src) === t)
      return;
    const i = new Image();
    if (i.src = t, i.complete) {
      I(i);
      return;
    }
    l(!0), i.onload = () => {
      I(i);
    };
  }, [t]);
  const P = () => {
    x({
      width: "100%",
      height: "100%"
    }), $({
      height: "100%",
      width: "100%"
    }), S({ x: 0, y: 0 }), p(1), d(1);
  };
  return C(() => {
    if (!a || !h.height)
      return;
    if (!e) {
      P(), l(!1);
      return;
    }
    const i = h.width / h.height, W = a.naturalWidth * e.width / (a.naturalHeight * e.height), { width: g, height: c } = X(
      h.width,
      h.height,
      W
    );
    if ($({
      height: `${c.toFixed(2)}px`,
      width: `${g.toFixed(2)}px`
    }), i > W) {
      const n = a.naturalWidth * e.width / 100;
      p(g / n);
    } else {
      const n = a.naturalHeight * e.height / 100;
      p(c / n);
    }
    if (x({
      width: `${a.naturalWidth}px`,
      height: `${a.naturalHeight}px`
    }), S({ x: e.x, y: e.y }), l(!1), s === "fill") {
      const n = h.width / g, T = h.height / c;
      d(Math.max(T, n));
    } else
      d(1);
  }, [h, a, s]), /* @__PURE__ */ m(Y, { ref: R, $scale: F, children: /* @__PURE__ */ m(
    k,
    {
      $width: w.width,
      $height: w.height,
      $aspect: e == null ? void 0 : e.aspect,
      children: /* @__PURE__ */ m(
        q,
        {
          src: t,
          alt: H,
          $scale: M,
          $translateX: y.x,
          $translateY: y.y,
          $width: u.width,
          $height: u.height,
          $objectFit: s === "fill" ? "cover" : "scale-down",
          $hideImage: !!e && j,
          $absolutePositioning: b,
          onError: v,
          ...E
        }
      )
    }
  ) });
}, Y = f.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  transform: scale(${({ $scale: t }) => t}, ${({ $scale: t }) => t});
`, k = f.div`
  position: relative;
  width: ${({ $width: t }) => t};
  height: ${({ $height: t }) => t};
  overflow: hidden;
  clip-path: ${({ $aspect: t }) => t === "circle" ? "circle(50% at center)" : void 0};
`, q = f.img`
  position: ${({ $absolutePositioning: t }) => t ? "absolute" : "static"};
  width: ${({ $width: t }) => t};
  height: ${({ $height: t }) => t};
  transform-origin: top left;
  object-fit: ${({ $objectFit: t }) => t};
  transform: scale(${({ $scale: t }) => t}, ${({ $scale: t }) => t})
    translate(
      -${({ $translateX: t }) => t}%,
      -${({ $translateY: t }) => t}%
    );
  visibility: ${({ $hideImage: t }) => t ? "hidden" : "visible"};
  // Ensure no problematic img styles get applied
  max-width: inherit !important;
  max-height: inherit !important;
`;
export {
  Q as CroppedImage
};
